<template>
    <loading name="load image detail">
        <div class="container body fix-footer">
            <div class="row justify-content-center">
                <div class="col-md-8 mt-5 mb-3">
                    <div class="card">
                        <div class="card-header">
                            <h3>{{$t('pages.EditSliderImage')}}</h3>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger" v-if="error">
                                {{$t(error)}}
                            </div>
                            <form @submit="submit">
                                <formly-form :form="form" :model="model" :fields="fields" ref="editImage"/>
                                <button type="submit" class="btn btn-primary">{{ $t('button.Save') }}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import { mapActions } from 'vuex';
  import isLength from 'validator/lib/isLength';
  import { ERROR_MESSAGES, ROUTER_NAMES } from '../../constants';

  export default {
    name: 'EditSliderImage',
    data() {
      return {
        error: '',
        form: {},
        model: {
          title: '',
          text: '',
          order: 0,
          active: false,
        },
        fields: [
          {
            key: 'image',
            type: 'image',
            templateOptions: {
              label: this.$t('fields.Image')
            },
            required: true
          },
          {
            key: 'title',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Title')
            },
            required: true,
            validators: {
              validTitle: {
                expression(field, model, next) {
                  next(isLength(model[field.key], { min: 3 }));
                },
                message: 'Nazov musi obsahovat aspoň 3 znaky'
              }
            }
          },
          {
            key: 'text',
            type: 'mce',
            templateOptions: {
              label: this.$t('fields.Content'),
            },
            required: true,
            validators: {
              validShort: {
                expression(field, model, next) {
                  next(isLength(model[field.key], {
                    min: 10
                  }));
                },
                message: this.$tc('validation.min', 10)
              }
            }
          },
          {
            key: 'active',
            type: 'checkbox',
            templateOptions: {
              label: this.$t('fields.Visible')
            },
            required: true,
          },
          {
            key: 'order',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Order'),
              inputType: 'number'
            },
            required: true,
          },
        ]
      };
    },
    created() {
      this.$wait.start('load image detail');
      this.loadSliderImages()
        .then(() => {
          this.model = Object.assign({}, this.image);
          this.$wait.end('load image detail');
        }).catch((e) => {
        const response = e.response ? e.response : {};
        if(response.status == 404) {
          this.$router.push({
            name: ROUTER_NAMES.NOT_FOUND,
            params: {
              0: ROUTER_NAMES.NOT_FOUND
            }
          })
        } else {
          this.$router.push({
            name: ROUTER_NAMES.ERROR
          })
        }
      });
    },
    computed: {
      image() {
        const result = this.state().images.allSliderImages.filter((image) => image.id == this.$route.params.id);

        return result.length ? result[0] : {}
      }
    },
    methods: {
      ...mapActions(['loadSliderImages', 'editImage']),
      submit(e) {
        e.preventDefault();

        this.$refs.editImage.validate()
          .then(() => {
            if (!this.form.$valid) return;

            this.editImage(this.model)
              .then(() => {
                  this.$router.push({
                    name: ROUTER_NAMES.SLIDER_IMAGES
                  });
              })
              .catch(() => {
                this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
              });
          });
      }
    }
  };
</script>

<style scoped>

</style>
